import { Box, Chip, Stack, useTheme } from "@mui/material";

import DatasetTypeChip from "src/views/datasets/components/DatasetTypeChip";
import { SearchResult } from "./SourceListItem";
import ChunkContent from "./ChunkContent";

type TSourceDataRecordChunkCard = {
  source: SearchResult;
  index: number;
  /**
   * DOM id for citation scroll-targeting. Defaults to ``source-${index}``;
   * tiers that aren't citation targets (e.g. Read) pass a non-colliding id so
   * they don't shadow the Cited cards' ``source-N`` anchors.
   */
  domId?: string;
};

const SourceDataRecordChunkCard = ({
  source,
  index,
  domId,
}: TSourceDataRecordChunkCard) => {
  const theme = useTheme();

  return (
    <Box
      id={domId ?? `source-${index}`}
      data-testid={`aa-src-item-${index - 1}`}
      sx={{
        borderRadius: 1,
        margin: "8px",
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box
        sx={{
          bgcolor: "#f5f5f5",
          width: "100%",
          minHeight: 50,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={{ width: "100%" }}
          gap={1}
          flexWrap="wrap"
        >
          <Chip
            label={index}
            size="small"
            sx={{
              fontWeight: "normal",
              border: `1px solid ${theme.palette.divider}`,
            }}
          />
          <DatasetTypeChip
            type={
              source?.source_data_record?.dataset_type ||
              source?.dataset?.dataset_type?.name ||
              "Document"
            }
            avatar
          />
          <Box
            sx={{
              fontWeight: "bold",
              textWrap: "wrap",
            }}
          >{`${
            source?.source_data_record?.file_name ||
            source?.dataset?.name ||
            "Unknown Dataset"
          } | #${source?.source_data_record?.id || "N/A"}`}</Box>
        </Stack>
      </Box>
      <Box
        sx={{
          padding: 2,
          bgcolor: theme.palette.background.paper,
        }}
      >
        <ChunkContent data={source?.source_data_record?.data} />
      </Box>
    </Box>
  );
};

export default SourceDataRecordChunkCard;
